var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#374336",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m981.6 218.4h-763.2v764.4h764.4l0.003906-764.4zm-39.602 723.6h-684v-684h685.2v684z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.8 1054.8h75.602v39.602h-75.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m698.4 1054.8h75.602v39.602h-75.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.6 1054.8h75.602v39.602h-75.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 1054.8h37.199v39.602h-37.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.8 60h39.602v37.199h-39.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m811.2 1054.8h75.602v39.602h-75.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.4 1054.8h75.602v39.602h-75.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 1054.8h75.602v39.602h-75.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.8 924h39.602v75.602h-39.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.8 585.6h39.602v75.602h-39.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.8 472.8h39.602v75.602h-39.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.8 360h39.602v75.602h-39.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.8 248.4h39.602v75.602h-39.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.8 811.2h39.602v75.602h-39.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m924 1054.8h75.602v39.602h-75.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.8 1054.8h-18v39.598h57.598v-57.598h-39.598z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.8 698.4h39.602v75.602h-39.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1140 105.6h-1034.4v1034.4h39.598v-45.602h64.801v-39.598h-64.801v-909.6h909.6v64.801h39.598v-64.801h45.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.2 883.2h177.6c10.801 0 19.199-8.3984 19.199-19.199s-8.3984-19.199-19.199-19.199h-130.8l138-138c7.1992-7.1992 7.1992-20.398 0-27.602-7.1992-7.1992-20.398-7.1992-27.602 0l-138 136.8v-130.8c0-10.801-8.3984-19.199-19.199-19.199s-19.199 8.3984-19.199 19.199v177.6c-1.1992 12 7.1992 20.398 19.199 20.398z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m685.2 356.4h130.8l-138 138c-7.1992 7.1992-7.1992 20.398 0 27.602 7.1992 7.1992 20.398 7.1992 27.602 0l138-138v129.6c0 10.801 8.3984 19.199 19.199 19.199s19.199-8.3984 19.199-19.199v-176.4c0-10.801-8.3984-19.199-19.199-19.199h-177.6c-10.801 0-19.199 8.3984-19.199 19.199s8.3984 19.199 19.199 19.199z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/size.a2ae93c0.svg";
export { ForwardRef as ReactComponent };